// src/planbarometer/PlanbarometerOptions.js

const API_URL = "https://vekstbarometer.usn.no/planbarometer/api/api/v1/aktive-nettsted";

export async function getPlanbarometerOptions() {
  try {
    const response = await fetch(API_URL);
    const data = await response.json();

    return data.map((item) => ({
      name: item.kommune,
      url: item.link,
    }));
  } catch (error) {
    console.error("Failed to fetch Planbarometer options:", error);
    return []; // Return empty array on error
  }
}
